
import { defineComponent } from 'vue'
import { UiTooltip } from '../keen-ui'
import { EpbBadge } from './epb-badge'

export default defineComponent({
  name: 'InputLabel',
  components: {
    UiTooltip,
    EpbBadge,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    showDescriptionAsBadge: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    level: {
      type: Number,
    },
    invalid: {
      type: Boolean,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-input-label',
    }
  },
  computed: {
    classes(): (string | Record<string, boolean>)[] {
      return [
        this.baseClass,
        {
          [`${this.baseClass}--invalid`]: this.invalid,
        },
      ]
    },
  },
})
